import { useState, useEffect } from 'react';

function useCodeLineStyling(element) {
  const [lineHeight, setLineHeight] = useState(16);
  const [fontSize, setFontSize] = useState(16);
  useEffect(() => {
    if (element) {
      const computedStyle = getComputedStyle(element);
      const lineHeightValue = parseFloat(computedStyle.lineHeight);
      setLineHeight(lineHeightValue);
      const fontSizeValue = parseFloat(computedStyle.fontSize);
      setFontSize(fontSizeValue);
    }
  }, [
    element
  ]);
  return {
    lineHeight,
    fontSize
  };
}

export { useCodeLineStyling };
//# sourceMappingURL=useCodeLineHeight.js.map
